import { useEffect } from "react";
import { Link } from "react-router";
import { useLedger, useMarkNotificationsRead, useMe, useNotifications } from "../api/hooks";
import { Card, Empty, QueryState, cx } from "../components/ui";
import { chips, relative } from "../lib/format";

export function NotificationsPage() {
  const me = useMe();
  const notes = useNotifications();
  const ledger = useLedger();
  const markRead = useMarkNotificationsRead();
  const unread = me.data?.unreadNotifs ?? 0;

  // Opening the page marks everything read. Keyed on the unread count only,
  // so a refetch doesn't re-fire it.
  const { mutate, isPending } = markRead;
  useEffect(() => {
    if (unread > 0 && !isPending) mutate();
  }, [unread]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Notifications</h1>
      {(me.data?.votableCount ?? 0) > 0 && (
        <Link to="/?status=VOTING" className="block rounded-xl border border-warn/40 bg-warn/10 px-4 py-3 text-sm">
          {me.data!.votableCount} market{me.data!.votableCount === 1 ? " is" : "s are"} waiting for your vote →
        </Link>
      )}
      <QueryState q={notes}>
        {() =>
          notes.data!.length === 0 ? <Empty>Nothing yet.</Empty> : (
            <Card>
              <ul className="divide-y divide-line text-sm">
                {notes.data!.map((n) => (
                  <li key={n.id} className={cx("flex justify-between gap-3 py-2", !n.read && "font-medium")}>
                    {n.marketId ? <Link to={`/m/${n.marketId}`} className="hover:underline">{n.text}</Link> : <span>{n.text}</span>}
                    <span className="shrink-0 text-xs text-muted">{relative(n.at)}</span>
                  </li>
                ))}
              </ul>
            </Card>
          )
        }
      </QueryState>

      <h2 className="pt-2 font-semibold">Chip history</h2>
      <QueryState q={ledger}>
        {() => (
          <Card>
            <ul className="divide-y divide-line text-sm">
              {ledger.data!.map((e) => (
                <li key={e.id} className="flex justify-between gap-3 py-2">
                  <span>
                    {e.type.replace(/_/g, " ").toLowerCase()}
                    {e.note && <span className="text-muted"> · {e.note}</span>}
                  </span>
                  <span className="shrink-0 text-right">
                    <span className={e.amountM >= 0 ? "text-yes" : "text-no"}>{chips(e.amountM, { signed: true })}</span>
                    <span className="ml-2 text-xs text-muted">{relative(e.at)}</span>
                  </span>
                </li>
              ))}
            </ul>
          </Card>
        )}
      </QueryState>
    </div>
  );
}
